import React from "react"
import {formatTextTestIds} from "@next/utils"
import {PriceLabel, PriceValue, PriceRowContainer, Container, WasPriceValue, SalePriceValue} from "../../components"

export const BundlePrice = ({
    tooltipTitle,
    shadePrice,
    saleShadePrice,
    bundlePrice,
    saleBundlePrice,
    basePrice,
    saleBasePrice,
    text,
    basesHasSale,
    shadesHasSale,
    bundlePriceAriaLabel,
    bundleBasePriceAriaLabel,
    bundleShadesPriceAriaLabel,
    wasBundlePriceText,
    saleBundlePriceText,
    wasShadePriceText,
    saleShadePriceText,
    wasBasePriceText,
    saleBasePriceText,
    bundleHasSale,
    brandedMarkdownSalePrice,
    bundlePriceLabel,
}) => {
    return (
        <Container>
            <PriceRowContainer
                title={tooltipTitle}
                variant="h5"
                data-testid={formatTextTestIds("bundle_summary_bundle_price")}
                aria-label={bundlePriceAriaLabel}
            >
                <PriceLabel isSalePrice={saleBundlePrice as boolean}>{bundlePriceLabel}</PriceLabel>
                {saleBundlePrice ? (
                    <>
                        <WasPriceValue data-testid={formatTextTestIds("was_bundle_price")}>
                            {wasBundlePriceText}
                        </WasPriceValue>
                        <SalePriceValue
                            data-testid={formatTextTestIds("sale_bundle_price")}
                            $brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                        >
                            {saleBundlePriceText}
                        </SalePriceValue>
                    </>
                ) : (
                    <PriceValue data-testid={formatTextTestIds("bundle_price")}>{bundlePrice}</PriceValue>
                )}
            </PriceRowContainer>
            {bundleHasSale && !saleBundlePrice && (
                <SalePriceValue
                    data-testid={formatTextTestIds("bundle_summary_bundle_placeholder")}
                    $brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                />
            )}

            <PriceRowContainer
                title={tooltipTitle}
                variant="h5"
                data-testid={formatTextTestIds("bundle_summary_base_price")}
                aria-label={bundleBasePriceAriaLabel}
            >
                <PriceLabel>{text.labels.base}</PriceLabel>
                {saleBasePrice ? (
                    <>
                        <WasPriceValue data-testid={formatTextTestIds("was_base_price")}>
                            {wasBasePriceText}
                        </WasPriceValue>
                        <SalePriceValue
                            data-testid={formatTextTestIds("sale_base_price")}
                            $brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                        >
                            {saleBasePriceText}
                        </SalePriceValue>
                    </>
                ) : (
                    <PriceValue data-testid={formatTextTestIds("base_price")}>{basePrice}</PriceValue>
                )}
            </PriceRowContainer>
            {basesHasSale && !saleBasePrice && <SalePriceValue $brandedMarkdownSalePrice={brandedMarkdownSalePrice} />}

            <PriceRowContainer
                title={tooltipTitle}
                variant="h5"
                data-testid={formatTextTestIds("bundle_summary_shade_price")}
                aria-label={bundleShadesPriceAriaLabel}
            >
                <PriceLabel>{text.labels.shades}</PriceLabel>
                {saleShadePrice ? (
                    <>
                        <WasPriceValue data-testid={formatTextTestIds("was_shade_price")}>
                            {wasShadePriceText}
                        </WasPriceValue>
                        <SalePriceValue
                            data-testid={formatTextTestIds("sale_shade_price")}
                            $brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                        >
                            {saleShadePriceText}
                        </SalePriceValue>
                    </>
                ) : (
                    <PriceValue data-testid={formatTextTestIds("shade_price")}>{shadePrice}</PriceValue>
                )}
            </PriceRowContainer>
            {shadesHasSale && !saleShadePrice && (
                <SalePriceValue $brandedMarkdownSalePrice={brandedMarkdownSalePrice} />
            )}
        </Container>
    )
}

export default BundlePrice
